import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Printer } from "lucide-react";
import { errMsg } from "@/lib/api";
import { ConfirmDelete, inp } from "@/components/admin/AdminUi";
import { cassa, cassaOpen, money } from "./cassaApi";

export function ReceiptsTab() {
  const [data, setData] = useState(null);
  const [year, setYear] = useState(null);
  const [q, setQ] = useState("");
  const load = () => cassa.get("/receipts", { params: { year: year || undefined, q } }).then((r) => setData(r.data)).catch((e) => toast.error(errMsg(e)));
  useEffect(() => { const t = setTimeout(load, 200); return () => clearTimeout(t); }, [year, q]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!data) return null;
  const del = async (r) => { try { await cassa.delete(`/receipts/${r.id}`); toast.success("Ricevuta eliminata"); load(); } catch (e) { toast.error(errMsg(e)); } };
  const tot = data.items.reduce((a, i) => a + +i.total, 0);
  return (
    <div className="space-y-4" data-testid="cassa-receipts-tab">
      <div className="flex flex-wrap gap-2 items-center">
        <select data-testid="cassa-rcp-year" value={data.year} onChange={(e) => setYear(+e.target.value)} className={inp.replace("w-full", "w-28")}>{data.years.map((y) => <option key={y}>{y}</option>)}</select>
        <input data-testid="cassa-rcp-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Numero o cliente" className={inp.replace("w-full", "w-64")} />
        <span className="ml-auto text-sm">{data.items.length} ricevute · <b>{money(tot)}</b></span>
      </div>
      <div className="rounded-xl border bg-white divide-y">
        {data.items.map((r) => (
          <div key={r.id} className="px-4 py-2.5 flex flex-wrap items-center gap-3 text-sm" data-testid={`cassa-rcp-row-${r.id}`}>
            <b className="font-mono w-24">{r.number}</b><span>{r.date.split("-").reverse().join("/")}</span>
            <span className="flex-1 min-w-[140px]">{r.client_name || <span className="text-slate-400">Senza cliente</span>}</span>
            <span className="text-xs text-slate-500">{r.pay_method}</span><b>{money(r.total)}</b>
            <button data-testid={`cassa-rcp-print-${r.id}`} onClick={() => cassaOpen(`/receipts/${r.id}/pdf`).catch((e) => toast.error(errMsg(e)))} className="press h-8 px-2 rounded border text-xs font-semibold flex items-center gap-1"><Printer className="w-3.5 h-3.5" /> Stampa</button>
            <ConfirmDelete small testId={`cassa-rcp-delete-${r.id}`} title={`Eliminare la ricevuta ${r.number}?`} text="La vendita verrà tolta da statistiche e storico cliente." onConfirm={() => del(r)} />
          </div>
        ))}
        {!data.items.length && <p className="p-5 text-sm text-slate-500">Nessuna ricevuta in questo anno.</p>}
      </div>
      <p className="text-xs text-slate-500">Ricevute non fiscali: lo scontrino fiscale va emesso dal registratore telematico (collegamento da attivare).</p>
    </div>
  );
}
